
import React from 'react';
import { Search } from 'lucide-react';

const BlogHeader = () => {
  return (
    <section className="pt-32 pb-20 bg-green-50 relative">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <span className="text-pkgreen-600 font-display uppercase tracking-wider text-sm mb-2 block animate-fade-up">
            Insights & Expertise
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold mb-6 text-gray-900 animate-fade-up">
            Our Blog
          </h1>
          <p className="text-xl text-gray-700 animate-fade-up mb-8">
            Expert tips, ideas, and insights for creating and maintaining beautiful landscapes in Fairfield County.
          </p>
          
          {/* Search Bar */}
          <div className="max-w-md mx-auto">
            <div className="relative">
              <input
                type="text"
                placeholder="Search articles..."
                className="w-full px-4 py-3 pl-12 rounded-md border border-gray-300 focus:border-pkgreen-500 focus:ring-2 focus:ring-pkgreen-200 transition-all duration-300 outline-none"
              />
              <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogHeader;
